import { CSSProperties } from "react";

export const getChildFrame = (): HTMLIFrameElement | undefined => {
  return document.getElementsByName("CONVERSATION_FRAME")[0] as HTMLIFrameElement;
};

export const updateParentStyle = (payload: CSSProperties) => {
  window.parent.postMessage(
    {
      messageType: "CHAT_FRAME_STYLE_UPDATE",
      payload,
    },
    "*"
  );
};

export const sendPostMessageToChild = (message: any) => {
  var childFrame = getChildFrame();
  if (childFrame) {
    childFrame.contentWindow?.postMessage(message, "*");
  }
};

export const sendMessageToChild = (message: string) => {
  var childFrame = getChildFrame();
  if (childFrame) {
    childFrame.contentWindow?.postMessage(
      {
        messageType: "REPLY_REQUEST_FROM_PARENT",
        payload: {
          message,
        },
      },
      "*"
    );
  }
};
